import { useState, useContext, useRef } from 'react';
import { ContextMenu } from 'primereact/contextmenu';
import { OverlayContext } from '../../OverlaysContext.js';
import { NewStopDialog } from '../stops/NewStopDialog.js';
import { useMapEvents } from 'react-leaflet';


export function MapContextMenu() {
    const handleOverlay = useContext(OverlayContext);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [visibleDialog, setVisibleDialog] = useState(false);
    const cm = useRef(null);
    const map = useMapEvents({
    contextmenu: (e) => {
        if (cm.current) {
        setSelectedLocation(e.latlng);
        cm.current.show(e.originalEvent);
        }
    }
    });
    const cmItems = [
      {
        label: 'Utwórz przystanek tutaj',
        icon: 'fa-solid fa-location-dot',
        command: () => {
          setVisibleDialog('newStopDialog');
        }
      },
      {
        label: 'Skopiuj koordynaty',
        icon: 'fa-solid fa-copy',
        command: async () => {
          const locationStr = selectedLocation.lat + ',' + selectedLocation.lng;
          try {
            await navigator.clipboard.writeText(locationStr);
            handleOverlay('toast', {
              severity: "success",
              summary: 'Pozycja skopiowana do schowka',
              detail: locationStr
            })
          } catch (error) {
            handleOverlay('toast', {
              severity: "error",
              summary: 'Kopiowanie nie udało się',
              detail: 'Możesz spróbować skopiować pozycję z tego okienka: \r\n ' + locationStr + '.\r\n Szczegóły błędu: ' + error.message
            })
          }
        }
      }
    ];
  
  
    return (
      <>      
        <ContextMenu popup model={cmItems} ref={cm} />
        {
          (selectedLocation) 
            ? 
            <NewStopDialog 
                stopLocation={selectedLocation}
                visible={(visibleDialog === 'newStopDialog')}
                onHide={() => {if (!visibleDialog === 'newStopDialog') return; setVisibleDialog(false); }}
            />
          : <></>
        }
      </>
    );
  }